import {
  isNumber, isLongitude, isLatitude, isJapanPhone,
} from '@/utils/reg';
// import IBMCheck from '@/font_check/IBM';
// import Izon from '@/font_check/Izon';
// import JIS3 from '@/font_check/JIS3';
// import JIS4 from '@/font_check/JIS4';
// import NEC_IBM from '@/font_check/NEC_IBM';
// import NEC from '@/font_check/NEC';
import KANA from '@/font_check/kanatable-j';
// import KATA from '@/font_check/KATA';
import { fonts } from '@/font_check/font';

// 版本号
const currentVersion = '1.0.0';
// 合并所有验证的字符
export const japaneseCharacters = fonts;
/** 判断table内的字是否溢出 */
export function checkTextOverflow(text) {
  const dummySpan = document.createElement('span');
  dummySpan.style.visibility = 'hidden';
  dummySpan.style.whiteSpace = 'nowrap';
  dummySpan.innerText = text;
  document.body.appendChild(dummySpan);
  const isOverflow = dummySpan.offsetWidth > 200;
  document.body.removeChild(dummySpan);
  return isOverflow;
}

/** 格式化溢出文字 */
export function truncateText(text, maxlength) {
  if (text.length > maxlength) {
    return `${text.substring(0, maxlength)}...`;
  }
  return text;
}

// 验证数字
export function validateNumber(length) {
  return (rule, value, callback) => {
    console.log(value);
    if (value && !isNumber(value)) {
      callback(new Error('有効な番号である必要があります'));
      // 必须为
    } else if (length && value && String(value).length !== 0 && String(value).length < length) {
      callback(new Error('6桁の数字を入力してください'));
    }else {
      callback();
    }
  }
}
// 验证数字且至少为6位数
// 验证数字必填
export function validateNumberRequired(rule, value, callback) {
  if (!value) {
    callback(new Error('IDを入力してください'));
  } else if (value && !isNumber(value)) {
    callback(new Error('有効な番号である必要があります'));
  } else {
    callback();
  }
}
// 验证是否空值
export function validateEmpty(msg = '', required = false, mode = '') {
  // 验证字符串是否有换行和tab代码
  return (rule, value, callback) => {
    if (value) {
      const reg = /\r\n|\r|\n|\t/;
      // 构建正则表达式
      const regexPattern = japaneseCharacters.join('|');
      const regex = new RegExp(regexPattern, 'g');
      const matches = value.match(regex);
      const kana8RegexPattern = [...KANA, 
        '０', '１', '２', '３', '４', '５', '６', '７', '８', '９',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].join('|');
      const kana8Regex = new RegExp(kana8RegexPattern, 'g');
      const kana8Regex2 = new RegExp(`^[${kana8RegexPattern}]+$`)
      const kana8NotMatches = value.replace(kana8Regex, '');
      if (reg.test(value)) {
        callback(new Error('正しいテキスト形式を入力してください'));
      } else if (mode === 'kana8' && !kana8Regex2.test(value)) {
        callback(new Error(`入力内容に機種依存文字が存在しています。「${kana8NotMatches}」`));
      } else if (matches) {
        callback(new Error(`入力内容に機種依存文字が存在しています。「${matches}」`));
      } else {
        callback();
      }
    } else if (required) {
      callback(new Error(msg));
    } else {
      callback();
    }
  };
}
// 验证かな8是否包含指定字符
export function validateKana8() {
  return (rule, value, callback) => {
    // const regexPattern = KANA.join('|');
    // const regex = new RegExp(regexPattern, 'g');
    // const matches = value.match(regex);
    if (!KANA.includes(value)) {
      callback(new Error('Please Input Correct Word'))
    } else {
      callback()
    }
  }
}

// 经纬度转化为度分秒
export const convertDMS = (longitude, latitude, type) => {
  // 转化为日本经纬度
  // const jd = (type === 'longitude' ? longitude : latitude) + (type === 'longitude' ? 0.000046047 : 0.00010696) * latitude - (type === 'longitude' ? 0.000083049 : 0.000017467) * longitude + (type === ) + (type === 'longitude' ? 0.010041 : 0.0046020);
  const j_longitude = longitude + 0.000046047 * latitude +0.000083049 * longitude - 0.010041;
  const j_latitude = latitude + 0.00010696 * latitude - 0.000017467 * longitude - 0.0046020;
  const jd = type === 'longitude' ? j_longitude : j_latitude;
  let d = Math.floor(jd); // 获取度
  const minfloat = Math.abs((jd - d) * 60); // 将小数度转换为分钟
  let m = Math.floor(minfloat); // 获取分钟
  const secfloat = (minfloat - m) * 60; // 将剩余的分钟转换为秒
  let s = Math.round(secfloat); // 获取秒
  // 对秒数进行四舍五入
  if (s === 60) {
    m++;
    s = 0;
  }
  if (m === 60) {
    d++;
    m = 0;
  }
  return [d, m, s]; // 以数组形式返回度、分、秒
};

// 验证经度
export function validateLongitude(rule, value, callback) {
  if (value && !isLongitude(value)) {
    callback(new Error('有効な経度である必要があります'));
  } else {
    callback();
  }
}

// 验证纬度
export function validateLatitude(rule, value, callback) {
  if (value && !isLatitude(value)) {
    callback(new Error('有効な緯度である必要があります'));
  } else {
    callback();
  }
}

// 验证电话号码
export function validatePhone(rule, value, callback) {
  const reg = /\r\n|\r|\n|\t/;
  // 构建正则表达式
  const regexPattern = japaneseCharacters.join('|');
  const regex = new RegExp(regexPattern, 'g');
  const matches = value ? value.match(regex) : '';
  if (value) {
    if (!isJapanPhone(value)) {
      callback(new Error('有効な電話番号である必要があります'));
    } else if (reg.test(value)) {
      callback(new Error('正しいテキスト形式を入力してください'));
    } else if (matches) {
      callback(new Error(`入力内容に機種依存文字が存在しています。「${matches}」`));
    } else {
      callback();
    }
  } else {
    callback();
  }
}

// 判断是否合法时间格式
export function isValidDate(str) {
  return !str && !Number.isNaN(Date.parse(str));
}
// 验证字符串是否有换行和tab代码
export function validCode(rule, value, callback) {
  const forbiddenPattern = /\\r|\\n|\\t|Ⅰ|Ⅱ|Ⅲ|Ⅳ|Ⅴ|Ⅵ|Ⅶ|Ⅷ|Ⅸ|Ⅹ|①|②|③|④|⑤|⑥|⑦|⑧|⑨|⑩|㈱|㈲|㍻|℡/;
  if (!value) {
    callback();
  } else if (value && forbiddenPattern.test(value)) {
    callback(new Error('正しいテキスト形式を入力してください'));
  } else {
    callback();
  }
}

export function checkVersionAndUpdateStorage() {
  const storedVersion = localStorage.getItem('appVersion');
  if (storedVersion !== currentVersion) {
    localStorage.removeItem('mergeSelectedList');
    localStorage.removeItem('targetId');
    localStorage.removeItem('mergeData');
    localStorage.setItem('appVersion', currentVersion); // 更新版本号
  }
}
